"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
// eslint-disable-next-line no-redeclare
var LoadingIndicator = function (_a) {
    var className = _a.className, color = _a.color, _b = _a.size, size = _b === void 0 ? 'medium' : _b;
    var classes = (0, classnames_1.default)("pg--loader", "pg--size-".concat(size), "pg--color-".concat(color), className);
    return (react_1.default.createElement("svg", { viewBox: "0 0 24 24", className: classes },
        react_1.default.createElement("circle", { cx: "12", cy: "12", r: "10", strokeWidth: "3", fill: "none" })));
};
LoadingIndicator.displayName = 'LoadingIndicator';
exports.default = LoadingIndicator;
